module.exports = __webpack_public_path__ + "img/1.7406b174.png";